const e = {
  type: {
    type: String,
    default: "info"
  },
  effect: {
    type: String,
    default: "light"
  },
  title: {
    type: String,
    default: ""
  },
  showIcon: {
    type: Boolean,
    default: !1
  }
}, o = {
  close: (t) => t instanceof MouseEvent
};
export {
  o as alertEmits,
  e as alertProps
};
